import { Component, Input, OnInit, ViewEncapsulation, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { OfferSortingOption } from '../offers-filters/offers-filters-model';

@Component({
  selector: 'sorting-modal-content',
  template: `
    <div class="sorting-modal-content">
      <div class="sorting-options-list">
        <div 
          class="sorting-option-item"
          *ngFor="let option of sortingOptions">

          <label class="option-label eva-3-body-1" [for]="'sorting-option-' + option.id">
            <span class="eva-3-radio -md ">
              <label class="radio-label-container" [for]="'sorting-option-' + option.id">
                <input class="radio-tag" [id]="'sorting-option-' + option.id" type="radio" name="sorting-options" [value]="option.id" [checked]="option.selected" (change)="selectOption(option)"/>
                <i class="radio-circle"></i>
              </label>
            </span>{{option.name}}
          </label>

        </div>
      </div>
    </div>
  `,
  styleUrls: ['./sorting-modal-content.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule],
  encapsulation: ViewEncapsulation.None
})
export class SortingModalContentComponent implements OnInit {
  @Input() sortingOptions: OfferSortingOption[] = [];
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() uniqueId?: string;
  @Input() isMobile?: boolean = false;
  @Input() sortingChangeCallback?: (selectedOption: OfferSortingOption) => void;

  @Output() sortingChangeEvent = new EventEmitter<OfferSortingOption>();

  selectedOption: OfferSortingOption | null = null;

  constructor() { }

  ngOnInit(): void {
    this.selectedOption = this.sortingOptions.find(option => option.selected) || null;
  }

  selectOption(selectedOption: OfferSortingOption): void {
    this.sortingOptions.forEach(option => {
      option.selected = false;
    });

    selectedOption.selected = true;
    this.selectedOption = selectedOption;

    if (this.sortingChangeCallback) {
      this.sortingChangeCallback(selectedOption);
    } else {
      this.sortingChangeEvent.emit(selectedOption);
    }
  }
}